import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";

export const PromocodFor = ({ promo }) => {
  let promoAppliedAta;
  let title;
  // console.log("promo", promo);

  // Determine what the promo is applied to
  if (promo?.promo_for === "Product") {
    promoAppliedAta = promo?.product;
    // console.log("product");
    title = "Product";
  } else if (promo?.promo_for === "Sub Category") {
    // console.log("subcategory");
    title = "Subcategory";
    promoAppliedAta = promo?.sub_category;
  } else if (promo?.promo_for === "Category") {
    // console.log("category");
    title = "Category";
    promoAppliedAta = promo?.category;
  } else {
    title = "Store";
  }

  // console.log("promoAppliedAta", promoAppliedAta);

  const [tabs] = useState([
    {
      header: title,
      children:
        promoAppliedAta && promoAppliedAta?.length > 0 ? (
          title === "Product" ? (
            <div>
              {promoAppliedAta && promoAppliedAta?.length > 0 ? (
                promoAppliedAta?.map((item) => {
                  return (
                    <div className=" mt-5 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                      <div className="p-6">
                        <h2 className="text-md font-bold mb-2 text-gray-900">
                          {item?.name}
                        </h2>
                        <p className="text-sm text-gray-600 mb-2">
                          Brand: {item?.brand}
                        </p>
                        <p className="text-sm text-gray-600 mb-2">
                          Model: {item?.model}
                        </p>
                        <p className="text-lg font-semibold text-[#145388] mb-4">
                          ₹{item?.sales_price?.$numberDecimal}
                          <span className="line-through text-gray-400 text-sm ml-2">
                            ₹{item?.cost_price?.$numberDecimal}
                          </span>
                        </p>

                        <div className="mb-4">
                          <span
                            className={`text-sm font-medium ${
                              item?.in_stock ? "text-green-600" : "text-red-600"
                            }`}
                          >
                            {item?.in_stock ? "In Stock" : "Out of Stock"}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="p-4 mt-5 bg-white border border-gray-200 rounded-lg shadow-lg">
                  <p className="text-sm text-gray-600">No Products found :(</p>
                </div>
              )}
            </div>
          ) : (
           (
              <div className="space-y-4">
                {promoAppliedAta?.map((item) => (
                  <div
                    key={item?.name}
                    className="p-4 mt-5 bg-white border border-gray-200 rounded-lg shadow-lg"
                  >
                    <h2 className="text-lg font-bold text-gray-800 mb-2">
                      {item?.name}
                    </h2>
                    <p className="text-sm text-gray-600">
                      The promocode is applied on all its
                      products
                    </p>
                  </div>
                ))}
              </div>
            )
          )
        ) :title==="Store"?(<div>
            <div className="p-4 mt-5 bg-white border border-gray-200 rounded-lg shadow-lg">
            <p className="text-sm text-gray-600">This promocode applied on all categories,subcategories and products of this store</p>
          </div>
        </div>):(
          <div className="p-4 mt-5 bg-white border border-gray-200 rounded-lg shadow-lg">
            <p className="text-sm text-gray-600">No Items found :(</p>
          </div>
        ),
    },
  ]);

  const createDynamicTabs = () => {
    return tabs.map((tab, i) => (
      <AccordionTab
        key={tab.header}
        header={
          <span className="text-lg font-semibold text-gray-800">
            {tab.header}
          </span>
        }
        disabled={tab.disabled}
      >
        {tab.children}
      </AccordionTab>
    ));
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-gray-50 rounded-lg shadow-lg border border-gray-200">
      <h1 className="text-xl border-b font-bold text-gray-800 pb-4 mb-6 text-center">
        Promo Code Applied
      </h1>
      <Accordion>{createDynamicTabs()}</Accordion>
    </div>
  );
};
